<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia/dist/pinia'
import router from '@/router'
import { useRoute } from 'vue-router/dist/vue-router'

import { useCalculationStore } from '@/stores/calculation'
import { useAuthorizationStore } from '@/stores/authorization'

import ProjectTitle from '@/components/project-detail/ProjectTitle.vue'
import CalculationForm from '@/components/calculation-form/CalculationForm.vue'
import { NAME } from '@/constants/calculationFieldConstants'
import { FORM, useDrawerStore } from '@/stores/drawer'

const route = useRoute()

const authorizationStore = useAuthorizationStore()
const drawerStore = useDrawerStore()

const { currentItem, fields, fetchLoading: calculationLoading } = storeToRefs(useCalculationStore())

const drawerModel = computed({
  get: () => drawerStore.formDrawerState,
  set: () => {
    toggleDrawer()
  }
})

const loading = computed(() => {
  return !currentItem.value?.id || calculationLoading.value
})

function navigateToCalculationPage() {
  router.push({ name: 'project-detail', params: { id: route.params.id } })
}

const toggleDrawer = () => {
  drawerStore.toggleCalculationDrawer(FORM)
}

const canChangeCalculation = computed(() => {
  return authorizationStore.hasServicePermission({
    authSource: 'ProjectUser',
    allowed: 'change_calculation'
  })
})
</script>

<template>
  <v-navigation-drawer
    v-model="drawerModel"
    scrim="rgba(0,0,0,0)"
    temporary
    elevation="2"
    width="500"
  >
    <v-list class="py-0">
      <v-list-item class="px-0" @click.stop="toggleDrawer">
        <template #title>
          <ProjectTitle />
        </template>
        <template #append>
          <v-btn
            variant="text"
            :icon="!drawerModel ? 'mdi-chevron-right' : 'mdi-chevron-left'"
            @click.stop="toggleDrawer"
          ></v-btn>
        </template>
      </v-list-item>
      <v-progress-linear v-if="loading" indeterminate color="primary"> </v-progress-linear>

      <template v-else>
        <v-divider></v-divider>
        <v-tooltip>
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
              prepend-icon="mdi-keyboard-return"
              @click="navigateToCalculationPage()"
            >
              <v-list-item-title class="tex-h6">
                {{ currentItem[NAME] }}
              </v-list-item-title>
            </v-list-item>
          </template>
          Back to calculations
        </v-tooltip>
        <v-divider></v-divider>
        <v-list class="pa-0 ma-0" :disabled="!canChangeCalculation">
          <template v-if="fields && !calculationLoading">
            <CalculationForm />
          </template>
        </v-list>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>
